import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CostService } from '../../../../service/cost.service';
import { JobSignatureService } from '../../../../service/job-signature.service';
import { AuthenticationService } from '../../../../service/system/authentication.service';

@Component({
  selector: 'app-job-detail-foot',
  templateUrl: './job-detail-foot.component.html',
  styleUrls: ['./job-detail-foot.component.less']
})
export class JobDetailFootComponent implements OnInit {
  @Output() nzOperaVote = new EventEmitter<any>();
  @Output() nzLinkVote = new EventEmitter<any>();
  @Input() job: any;
  @Input() listOfAllData = [];
  @Input() code: number; // code 0 详情 1 编辑 2 处置 3 历史详情，与详情的区别是只显示工单内容，不再显示查看知识库、备件库等功能
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData = [];
  isTransfer = false;
  isThirdService = false;
  currentCheckedIndex = '-1';
  mapOfCheckedId: { [key: string]: boolean } = {};
  numberOfChecked = 0;
  listCost = [];
  thirdpartyJobPocess = false;
  thirdpartyJobSignature = false;
  jobDetailToPdf = false;
  signatureList = [];

  constructor(
    private authService: AuthenticationService,
    private modalService: NzModalService,
    private costService: CostService,
    private jobSignatureService: JobSignatureService,
    private messageService: NzMessageService
    ) { }
  async ngOnInit() {
    this.listCost = await this.costService.getCostByJobId(this.job.jno);
    this.jobDetailToPdf = this.authService.getStatusByDictTypeAndDictValue('function_control', 'job_detail_to_pdf');
    this.getSignatureList(this.job.jno);
  }
  // tslint:disable-next-line:use-lifecycle-interface
  async ngOnChanges(changes: SimpleChange) {
    this.listCost = await this.costService.getCostByJobId(this.job.jno);
  }
  currentPageDataChange($event: any[]): void {
    if (this.listOfDisplayData.length > 0) {
      this.listOfDisplayData = $event;
      this.refreshStatus(true);
    }
  }

  refreshStatus(checked: boolean): void {
    if (checked) {
      if (Object.keys(this.mapOfCheckedId).length <= 1) {
        // tslint:disable-next-line:forin
        for (const key in this.mapOfCheckedId) {
          this.currentCheckedIndex = key;
        }
      } else {
        delete this.mapOfCheckedId[this.currentCheckedIndex];
        // tslint:disable-next-line:forin
        for (const key in this.mapOfCheckedId) {
          this.currentCheckedIndex = key;
        }
      }
    } else {
      delete this.mapOfCheckedId[this.currentCheckedIndex];
      this.currentCheckedIndex = '-1';
    }
    this.isAllDisplayDataChecked = this.listOfDisplayData
      .every(item => this.mapOfCheckedId[item.userId]);
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item.userId]) &&
      !this.isAllDisplayDataChecked;
    this.numberOfChecked = this.listOfAllData.filter(item => this.mapOfCheckedId[item.userId]).length;
  }

  public getCheckedItem() {
    if (this.numberOfChecked > 0) {
      return this.listOfAllData.filter(item => this.mapOfCheckedId[item.userId]);
    } else {
      return null;
    }
  }
  public setTransfer(st: boolean) {
    this.isTransfer = st;
  }
  public setThirdService(isThirdService: boolean){
    this.isThirdService = isThirdService;
  }
  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.userId] = value));
    this.refreshStatus(true);
  }
  // 操作 code表示操作类型 0：受理 1：派发 2：重派 3：转出 4:关闭 5:编辑
  operateFunction(code: number) {
    let title = '';
    let content = '';

    switch (code) {
      case 2:
        title = '派发';
        content = '确定派发工单';
        break;
      case 3:
        title = '重派';
        content = '确定重派工单';
        break;
      case 4:
        title = '转出';
        content = '确定转出类型';
        break;
      case 5:
        title = '修改';
        content = '确定修改工单';
        break;
    }
    if (code === 2 || code === 3 || code === 4 || code === 5) {
      this.modalService.confirm({
        nzTitle: title,
        nzContent: content,
        nzOkText: '确定',
        nzCancelText: '取消',
        nzOnOk: () => {
          this.nzOperaVote.emit(code);
        }
      });
    } else {
      this.nzOperaVote.emit(code);
    }
  }
  openFunction(code: number) {
    this.nzLinkVote.emit(code);
  }
  getSignatureList(jobId){
    this.jobSignatureService.getJobSignatureListByJno(jobId).then((response: any) => {
      if (response != null){
        response.forEach((item: any) => {
          item.isDisplayDelete = false;
        });
        this.signatureList =  response;
      }
    });
  }
  signatureMouseEnter(item: any){
    item.isDisplayDelete = true;
  }
  signatureMouseLeave(item: any){
    item.isDisplayDelete = false;
  }
  deleteSignature(id: any){
    this.modalService.confirm({
      nzTitle: '确定删除该签名？',
      nzContent: '<b style="color: red;">删除之后不可恢复，谨慎操作！</b>',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOkType: 'danger',
      nzOnOk: () => {
        this.jobSignatureService.deleteJobSignature(id).then((result: any) => {
          if ( result != null){
            this.getSignatureList(this.job.jno);
          }else{
            this.messageService.error('删除失败');
          }
        });
      }
    });
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  public isNaN(obj: any) {
    // tslint:disable-next-line:radix
    return isNaN(parseInt(obj));
  }
  public parseNumber(status: string){
    return Number(status);
  }
}
